import React, { useEffect, useState, useRef } from 'react';
import './HRLServicesUtility.css'
import { Link } from 'react-router-dom';
import SubscribeForm from '../SubscribeFormFolder/SubscribeForm';
import {
    LazyLoadImage,
    LazyLoadComponent,
} from 'react-lazy-load-image-component';

// Assets
// Background video
const BannerBg = require('./videos/utility-page-video.mp4');
const BannerBg_LazyLoadImg = require('./img/utility-lazyload.png');

// Gifs
import lightningGif from './gifs/EmergencyPreparedness.gif'

// Images
import utilityBg2 from './img/utility-bg2.png'

// Hero button images
import whiteTree from './img/ai-white.png'
import blueTree from './img/ai-blue.png'
import whiteHeli from './img/emergency-white.png'
import blueHeli from './img/emergency-blue.png'
import laptopMock from './img/laptop-mockup1.png'
import papers from './img/utility-pages.png'
import utilitImg1 from './img/utility-image1.png'

// Icons
import { FaArrowRight } from "react-icons/fa6";
import { FiDownload } from "react-icons/fi";

export type DownloadableDocs = {
    docName: string;
    type: string;
    file: any;
    datetime: string;
};

const HRLServicesUtility = () => {

    // Section for the video and its lazyLoad functionality
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);

    // Hero button hover logic
    const [hoveredCard, setHoveredCard] = useState<"land" | "air" | null>(null);
    const wildfireRef = useRef<HTMLHeadingElement>(null);
    const foreflightRef = useRef<HTMLDivElement>(null);

    const [doc, setDoc] = useState<DownloadableDocs[]>([]);
    const [showInput, setShowInput] = useState(false);
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const fetchDocs = async () => {
        try {
            const response = await fetch('/api/downloadable_pdf/', {
                method: 'GET',
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data: DownloadableDocs[] = await response.json();
            setDoc(data); // Assign the fetched posts to state
        } catch (err) {
            // Type assertion to 'Error' to access the message property
            if (err instanceof Error) {
                setError(err.message); // Handle error
            } else {
                setError('An unknown error occurred'); // Fallback for unknown errors
            }
        }
    };

    useEffect(() => {
        fetchDocs();
    }, []); // Empty dependency array to run once on mount


    const handleDownloadClick = () => {
        setShowInput(true);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const response = await fetch(
                'https://d427d68c.sibforms.com/serve/MUIFAFm-IrVl5PRcxStBFL6ifcgtG43uaN0ezlYBOFbiby_JOlb0QBM77oDTfImZ7ff380Ozpg6Sm1METyVUKjDHHSgfR5cvWvwTbp_AEgT48nYKSLXjrHQN3uecyhS-gGNgUGa-kejKXrbOpFAqhJGCuB8SGt1VLsNYBmVadOrN2hKzoAx_713mpRIlgyrQi5MWAHcb3pmajtpO',
                {
                    method: 'POST',
                    mode: 'no-cors', // suppress CORS errors
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        EMAIL: email,
                    }).toString(),
                }
            );

            setSubmitted(true);
            setError('');
            setShowInput(false);

            const mostRecentAIDoc = doc
                .filter(d => d.type === 'AI')
                .sort((a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime())[0];

            // Trigger the PDF download
            const link = document.createElement('a');
            link.href = mostRecentAIDoc.file; // Adjust if this is a public path
            link.target = '_blank';
            link.rel = 'noopener noreferrer'; // for security
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Reset email after 6 seconds
            setTimeout(() => {
                setSubmitted(false);
                setEmail('');
            }, 6000);
        } catch (err) {
            console.error('Error submitting the form:', err);
            setError('Something went wrong. Please try again.');
        }
    };


    return (
        <div className="detector-container">

            {/* Cover Section */}
            <div className="detector-hero-section">
                {!isVideoLoaded && (
                    <LazyLoadComponent
                        placeholder={<img src={BannerBg_LazyLoadImg} alt="" />}
                    >
                        <LazyLoadImage
                            src={BannerBg_LazyLoadImg}
                            alt="="
                            className="hero-image"
                        />
                    </LazyLoadComponent>
                )}

                <video
                    className={`hero-image ${isVideoLoaded ? '' : 'hidden'}`}
                    src={BannerBg}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onLoadedData={() => setIsVideoLoaded(true)}
                />

                <div className="dark-overlay"></div> {/* ← Overlay */}

                <div className="utility-hero-info-wrapper">
                    <h1><strong> Power Delivery  <br />Solutions</strong></h1>

                    <div className='land-air-cards'>
                        <div
                            className='land-air-card1 opa'
                            onMouseEnter={() => setHoveredCard('land')}
                            onMouseLeave={() => setHoveredCard(null)}
                            onClick={() => {
                                if (wildfireRef.current) {
                                    const yOffset = -45; // scroll 80px above the element
                                    const y = wildfireRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
                                    window.scrollTo({ top: y, behavior: 'smooth' });
                                }
                            }}
                        >
                            <img
                                className="land-air-img"
                                alt="tree"
                                src={hoveredCard === 'land' ? blueTree : whiteTree}
                            />
                            <p>Automated Damage <br /> Classification and Assessment  </p>
                        </div>
                        <div
                            className='land-air-card1 opb'
                            onMouseEnter={() => setHoveredCard('air')}
                            onMouseLeave={() => setHoveredCard(null)}
                            onClick={() => {
                                if (foreflightRef.current) {
                                    const yOffset = -30; // scroll 80px above the element
                                    const y = foreflightRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
                                    window.scrollTo({ top: y, behavior: 'smooth' });
                                }
                            }}
                        >
                            <img
                                className="land-air-img3"
                                alt="heli"
                                src={hoveredCard === 'air' ? blueHeli : whiteHeli}
                            />
                            <p>Emergency<br />Preparedness Team</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* High Risk Section */}
            <div className="high-risk-section">
                <div className='high-risk-info-wrapper'>
                    <h1 className='the-h1'>Minimizing Lightning Impact</h1>

                    <h2 className='the-h2'>Lightning is one of the most destructive and often underestimated threats
                        to power distribution systems. In 2023 alone, lightning-related insurance claims in the U.S.
                        surged to <span className='glow-blue'>$1.27 billion</span>, marking a <span className='glow-blue'>
                            30% increase </span> from the previous year. FNN’s High-Risk-Lightning™ detection technology helps
                        utilities anticipate and respond to these threats, minimizing outages and protecting vital infrastructure
                        before damage occurs.</h2>

                    <Link to="/hrl-detector" className='the-button2'>
                        <span>Explore services</span>
                    </Link>
                </div>
            </div>

            <div className="high-risk-section">
                <img className="wildfire-image2" alt="action background" src={utilityBg2} />
            </div>

            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                <div className="high-risk-section responsive-order">
                    <div className='high-risk-info-wrapper'>
                        <h1 className='the-h1' ref={wildfireRef}>FNN™ Dashboards Integrated into ADMS</h1>

                        <h2 className='the-h2'>FNN™ identifies dangerous lightning events using its proprietary <span className='glow-blue'>
                            High Risk Lightning™ (HRL™) detection systems</span>, which combine field-based sensors with real-time smart grid
                            and power asset data. Leveraging advanced AI signal processing, the <span className='glow-blue'> HRL™ identification
                            and notification services</span> enable rapid fault localization—supporting accurate damage assessments and targeted
                            restoration efforts.
                        </h2>
                    </div>

                    <Link to="/contact" className='the-utility-button'>
                        <span>Learn More</span>
                    </Link>
                </div>

                {/* Laptop section */}
                <img className="laptop-image" alt="action background" src={laptopMock} />
            </div>

            {/* Downlod Section */}
            <div className='whitePaper-section-parent'>
                <div className='wildfire-card'>
                    <div className='wildfire-info-wrapper'>
                        <h1 className='the-wild-h1'>AI Based HRL™ White Paper</h1>
                        <h2 className='the-h2'>
                            Download FNN’s whitepaper to learn how lightning impacts power
                            distribution and transmission teams—and how FNN’s solutions enhance
                            efficiency while reducing operations and maintenance (O&M) costs.
                        </h2>

                        {submitted ? (
                            <div className="download-message">
                                <h1>Download successful!</h1>
                            </div>
                        ) : showInput ? (
                            <form className="download-input-wrapper" onSubmit={handleSubmit}>
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    className="subs-input"
                                    value={email}
                                    required
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <button className="the-paper-button" type="submit">
                                    Download <FaArrowRight />
                                </button>
                            </form>
                        ) : (
                            <button className="the-paper-button" onClick={handleDownloadClick}>
                                Download <FaArrowRight />
                            </button>
                        )}

                    </div>

                    <div className='papers-and-download'>
                        <img className="papers-image" alt="action background" src={papers} />
                        <button
                            className='paper-download-button'
                            onClick={handleDownloadClick}>
                            <FiDownload className='dw-icon' />
                        </button>
                    </div>
                </div>
            </div>

            {/* Emergency Preparedness */}
            <div className="action-section">
                <div className='action-info-wrapper'>
                    <h1 className='the-h1' ref={foreflightRef}>Emergency Preparedness</h1>

                    <h2 className='the-h2'>FNN™ delivers actionable intelligence for emergency situations—from
                        wildfires to hurricanes—by providing<span className='glow-blue'> real-time alerts</span> when
                        active fires threaten utility infrastructure or when High-Risk-Lightning™ (HRL™) supercells
                        pose a risk to power grid stability during hurricanes. On average, FNN™ detects fire ignitions
                        <span className='glow-blue'> five hours </span>earlier than state emergency agencies.</h2>

                    <Link to="/hrl-detector" className='the-button'>
                        <span>Learn More</span>
                    </Link>

                </div>

                <img className="action-image" alt="action background" src={lightningGif} />
            </div>

            <SubscribeForm />
        </div>
    )
}

export default HRLServicesUtility